import React from 'react'
import photo from './images/photo.png'
function AddTaskButton() {
  return (
    <React.Fragment>
      <div className="addbutton">
        <div className="image">
          <img src={photo} alt="tasks" />
        </div>
      </div>
    </React.Fragment>
  )
}
export default AddTaskButton